import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import notice from '@/views/notice'
import unit from '@/views/unit'
import personal from '@/views/personal'
import area from '@/views/area'
import query from '@/views/query'
import queryResult from '@/views/queryResult'
import cxm from '@/views/cxm'
import county from '@/views/county'

Vue.use(Router)

export default new Router({
  mode: 'history',
    scrollBehavior: () => ({
        y: 0,
    }),
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/notice',
      name: 'notice',
      component: notice
    },{
      path: '/unit',
      name: 'unit',
      component: unit
    },
    {
      path: '/personal',
      name: 'personal',
      component: personal
    },{
      path: '/area',
      name: 'area',
      component: area
    },{
      path: '/query',
      name: 'query',
      component: query
    },{
      path: '/queryResult',
      name: 'queryResult',
      component: queryResult
    },{
      path: '/cxm',
      name: 'cxm',
      component: cxm
    },{
      path: '/county',
      name: 'county',
      component: county
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js